import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/auth";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAaJBO4gDsyCKhsRDTTJ-023tDbM92GeF4",
  authDomain: "negarit-fa56d.firebaseapp.com",
  projectId: "negarit-fa56d",
  storageBucket: "negarit-fa56d.appspot.com",
  messagingSenderId: "441589145421",
  appId: "1:441589145421:web:15daddf9915b23c35c6104",
};
// Initialize Firebase

firebase.initializeApp(firebaseConfig);
firebase.analytics();
firebase.firestore().settings({ timestampsInSnaphots: true });

export const storage = firebase.storage();
export default firebase;
